/*==================================================
  HERSHOP — SALE DROP (v9 — flat circular wheel,
  split desktop/mobile config + mobile nav arrows)

  WHY THIS CHANGED FROM v8:
  v8 had a single set of wheel-shape constants shared
  between desktop and mobile. v9 splits those into
  WHEEL_CONFIG.desktop / WHEEL_CONFIG.mobile so each
  breakpoint can be tuned independently (step, dip,
  scale falloff, visible range) without touching the
  other. The active config is picked in measure() based
  on window width, using the same 767px breakpoint the
  CSS already uses for its mobile rules — so JS and CSS
  switch together.

  v9 also wires up a pair of on-canvas mobile arrow
  buttons (data-hershop-sale-mobile-prev / -next) so
  touch users get an explicit "this is a carousel" cue
  in addition to swipe. They call the exact same goTo()
  as the desktop header arrows and the swipe handler, so
  behavior (wrap-around, render, progress bar) stays
  identical across all three input methods.

  Everything else — the flat-arc positioning logic, the
  fixed absolute stage, wrap-around navigation, quick-add
  — is unchanged from v8.

  Vanilla JS
==================================================*/

(function () {
  'use strict';

  var TOAST_MS = 1800;
  var SWIPE_THRESHOLD = 40;

  // --- Wheel shape controls -------------------------------
  // Separate config per breakpoint — desktop/tablet gets one
  // feel, mobile gets its own (smaller step, tighter dip, etc).
  // Same breakpoint as the CSS mobile rules (767px) so JS and
  // CSS switch together.
  var MOBILE_BREAKPOINT = 767;

  var WHEEL_CONFIG = {
    desktop: {
      // How far apart (as a fraction of the circle's own width)
      // each step on the arc sits horizontally. 1 means each
      // neighbour sits a full circle-width away.
      X_STEP_RATIO: 1,

      // How much the arc dips vertically per step, squared —
      // offset 1 dips ARC_DIP_RATIO, offset 2 dips 4x that.
      // Small values (0.04-0.08) read as a gentle wheel curve
      // rather than a sharp V. Set to 0 for a perfectly straight
      // fan.
      ARC_DIP_RATIO: 0.20,

      // How much smaller each step gets. Active card is scale 1;
      // offset 1 is (1 - SCALE_STEP), offset 2 is (1 - 2*SCALE_STEP).
      SCALE_STEP: 0.20,
      SCALE_MIN: 0.1,

      // How many cards on either side of the active one are
      // ever actually shown (matches the [data-offset="-2"..."2"]
      // opacity rules in the CSS — keep these in sync).
      VISIBLE_RANGE: 5
    },
    mobile: {
      // Tighter horizontal step on small screens — keeps more
      // of each neighbour on-screen instead of pushing them past
      // the narrow viewport edge.
      X_STEP_RATIO: 0.5,

      // Slightly flatter dip on mobile so the wheel doesn't feel
      // like it's climbing/falling too aggressively on a short
      // viewport.
      ARC_DIP_RATIO: 0.10,

      SCALE_STEP: 0.20,
      SCALE_MIN: 0.5,
      VISIBLE_RANGE: 5
    }
  };
  // ---------------------------------------------------------

  function activeWheelConfig() {

    return window.innerWidth <= MOBILE_BREAKPOINT
      ? WHEEL_CONFIG.mobile
      : WHEEL_CONFIG.desktop;

  }

  function initSection(root) {

    var viewport = root.querySelector('[data-hershop-sale-viewport]');
    var rail = root.querySelector('[data-hershop-sale-rail]');
    var prevBtn = root.querySelector('[data-hershop-sale-prev]');
    var nextBtn = root.querySelector('[data-hershop-sale-next]');
    var mobilePrevBtn = root.querySelector('[data-hershop-sale-mobile-prev]');
    var mobileNextBtn = root.querySelector('[data-hershop-sale-mobile-next]');
    var progressFill = root.querySelector('[data-hershop-sale-progress]');
    var toast = root.querySelector('[data-hershop-sale-toast]');
    var cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-hershop-sale-card]')
    );

    if (!rail || !viewport || !cards.length) return;

    // Works fine for a handful of cards or up to ~40 — the
    // count itself never changes how this loop behaves.
    var total = cards.length;
    var activeIndex = 0;

    var toastTimer = null;
    var xStep = 0;
    var arcDip = 0;
    var cfg = WHEEL_CONFIG.desktop;

    function measure() {

      // Step sizes are derived from the rendered circle size so
      // they stay correct across the desktop/tablet/mobile
      // max-width breakpoints defined in the CSS. Any card's
      // media works for this — they're all the same base size
      // before scale is applied.
      var mediaEl = cards[0].querySelector('.hershop-sale-card-media');
      var circleWidth = mediaEl
        ? mediaEl.getBoundingClientRect().width
        : 380;

      cfg = activeWheelConfig();

      xStep = circleWidth * cfg.X_STEP_RATIO;
      arcDip = circleWidth * cfg.ARC_DIP_RATIO;

      render();

    }

    function shortestOffset(index) {

      // Signed distance from activeIndex to index, choosing
      // whichever direction (forward or backward around the
      // wheel) is shorter — this is what makes wrap-around
      // (last -> first, first -> last) rotate the short way
      // instead of spinning all the way around.
      var raw = index - activeIndex;
      var half = total / 2;

      if (raw > half) raw -= total;
      if (raw < -half) raw += total;

      return raw;

    }

    function render() {

      cards.forEach(function (card, i) {

        var offset = shortestOffset(i);
        var absOffset = Math.abs(offset);

        card.dataset.offset = offset;

        var media = card.querySelector('.hershop-sale-card-media');

        if (!media) return;

        // Only bother positioning the spokes that are actually
        // visible — everything else is opacity:0 in CSS already,
        // so its transform doesn't matter and we skip the work.
        if (absOffset <= cfg.VISIBLE_RANGE) {

          var x = offset * xStep;
          var y = arcDip * (offset * offset);

          var scale = Math.max(
            cfg.SCALE_MIN,
            1 - absOffset * cfg.SCALE_STEP
          );

          media.style.transform =
            'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ')';

          // Active card sits on top; each step out goes a layer
          // behind it, so the wheel overlaps correctly regardless
          // of DOM order.
          media.style.zIndex = String(10 - absOffset);

        }

      });

      if (progressFill) {

        var pct = total > 1 ? (activeIndex / (total - 1)) * 100 : 100;

        progressFill.style.width = pct + '%';

      }

    }

    function goTo(index) {

      // Real wheel wrap: modulo instead of clamping, so the
      // wheel spins continuously past either end.
      activeIndex = ((index % total) + total) % total;

      render();

    }

    if (nextBtn) {

      nextBtn.addEventListener('click', function () {

        goTo(activeIndex + 1);

      });

    }

    if (prevBtn) {

      prevBtn.addEventListener('click', function () {

        goTo(activeIndex - 1);

      });

    }

    // On-canvas mobile arrows — same goTo() as the desktop header
    // arrows and swipe handler, just an explicit tappable "this is
    // a carousel" affordance sitting right on the wheel for touch
    // users.
    if (mobilePrevBtn) {

      mobilePrevBtn.addEventListener('click', function () {

        goTo(activeIndex - 1);

      });

    }

    if (mobileNextBtn) {

      mobileNextBtn.addEventListener('click', function () {

        goTo(activeIndex + 1);

      });

    }

    var resizeTimer = null;

    window.addEventListener('resize', function () {

      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(measure, 150);

    });

    cards.forEach(function (card, i) {

      var media = card.querySelector('.hershop-sale-card-media');

      if (!media) return;

      media.addEventListener('click', function (e) {

        if (Number(card.dataset.offset) !== 0) {

          e.preventDefault();

          goTo(i);

        }

      });

    });

    var touchStartX = 0;
    var touchStartY = 0;
    var isTracking = false;

    viewport.addEventListener('touchstart', function (e) {

      var t = e.touches[0];

      touchStartX = t.clientX;
      touchStartY = t.clientY;

      isTracking = true;

    }, { passive: true });

    viewport.addEventListener('touchend', function (e) {

      if (!isTracking) return;

      isTracking = false;

      var t = e.changedTouches[0];

      var deltaX = t.clientX - touchStartX;
      var deltaY = t.clientY - touchStartY;

      if (
        Math.abs(deltaX) < SWIPE_THRESHOLD ||
        Math.abs(deltaX) < Math.abs(deltaY)
      ) {
        return;
      }

      if (deltaX < 0) {

        goTo(activeIndex + 1);

      } else {

        goTo(activeIndex - 1);

      }

    }, { passive: true });

    measure();

    root.querySelectorAll('[data-hershop-sale-img]').forEach(function (img) {

      if (img.complete && img.naturalWidth > 0) {

        img.classList.remove('is-loading');

        return;

      }

      var clear = function () {

        img.classList.remove('is-loading');

        img.removeEventListener('load', clear);
        img.removeEventListener('error', clear);

      };

      img.addEventListener('load', clear);
      img.addEventListener('error', clear);

    });

    function showToast(message) {

      if (!toast) return;

      toast.textContent = message;

      toast.classList.add('is-visible');

      if (toastTimer) clearTimeout(toastTimer);

      toastTimer = setTimeout(function () {

        toast.classList.remove('is-visible');

      }, TOAST_MS);

    }

    root.querySelectorAll('[data-hershop-sale-quick-add]').forEach(function (btn) {

      btn.addEventListener('click', function (e) {

        e.preventDefault();

        var variantId = btn.getAttribute('data-variant-id');

        if (!variantId || btn.disabled) return;

        var addedLabel =
          btn.getAttribute('data-added-label') || 'Added';

        btn.disabled = true;
        btn.classList.add('is-loading');

        fetch(
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1
                }
              ]
            })
          }
        )
          .then(function (response) {

            if (!response.ok)
              throw new Error('cart add failed');

            return response.json();

          })
          .then(function () {

            btn.classList.remove('is-loading');
            btn.classList.add('is-added');

            var titleEl =
              btn.closest('[data-hershop-sale-card]')
                ? btn
                    .closest('[data-hershop-sale-card]')
                    .querySelector('.hershop-sale-product-title')
                : null;

            showToast(
              addedLabel +
                (titleEl
                  ? ' — ' +
                    titleEl.textContent.trim()
                  : '')
            );

            document.dispatchEvent(
              new CustomEvent('cart:refresh')
            );

            setTimeout(function () {

              btn.classList.remove('is-added');

              btn.disabled = false;

            }, TOAST_MS);

          })
          .catch(function () {

            btn.disabled = false;

            btn.classList.remove('is-loading');

            showToast("Couldn't add to cart");

          });

      });

    });

  }

  function initAll() {

    var sections =
      document.querySelectorAll('[data-hershop-sale]');

    for (var i = 0; i < sections.length; i++) {

      initSection(sections[i]);

    }

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }

  document.addEventListener(
    'shopify:section:load',
    function (e) {

      var root =
        e.target.querySelector('[data-hershop-sale]');

      if (root) {

        initSection(root);

      }

    }
  );

})();